import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

// Create client with auth persistence enabled.
// Both aviado.com and aviado.com/research share the same Supabase project,
// so authenticated sessions from the main app are detectable here via
// shared localStorage (same origin: aviado.com).
export const supabase: SupabaseClient | null =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
        },
        // Attribute server-side (SSR/RSC) traffic in Supabase edge logs.
        // Without this, every Node caller collapses into the default
        // `supabase-js-node/<ver>` UA, which prevents per-project
        // correlation in the main repo's scripts/sb-fn-logs.sh.
        global: {
          headers: { 'x-client-info': 'aviado-research-library' },
        },
      })
    : null;
